//Require products JS
require('./_accordion');
require('./_dropdowns');